import { DynamicObject } from 'src/utils/commonTypes';

export const learnMoreAboutPlex1 = (z5Strings: DynamicObject) => {
  return [
    {
      title: z5Strings.How_Questions_WhatisZeePlex_Text,
      descriptionItems: [[z5Strings.How_Answers_WhatisZeePlex_Text]]
    }
  ];
};

export const learnMoreAboutPlex2 = (z5Strings: DynamicObject) => {
  return [
    {
      title: z5Strings.How_Questions_HowtowatchcontentonZEEPlex_Text,
      descriptionItems: [
        [z5Strings.How_Answers_HowtowatchcontentonZEEPlex1_Text],
        [z5Strings.How_Answers_HowtowatchcontentonZEEPlex2_Text],

        [
          z5Strings.How_Answers_HowtowatchcontentonZEEPlex3_Text,
          z5Strings.How_Answers_HowtowatchcontentonZEEPlex4_Text,
          z5Strings.How_Answers_HowtowatchcontentonZEEPlex5_Text,
          z5Strings.How_Answers_HowtowatchcontentonZEEPlex6_Text
        ],

        [z5Strings.How_Answers_HowtowatchcontentonZEEPlex7_Text],
        [z5Strings.How_Answers_HowtowatchcontentonZEEPlex8_Text],
        [z5Strings.How_Answers_HowtowatchcontentonZEEPlex9_Text],
        [z5Strings.How_Answers_HowtowatchcontentonZEEPlex10_Text]
      ]
    },
    {
      title: z5Strings.How_Questions_ValidityLeftQuestion_Text,
      descriptionItems: [[z5Strings.How_Answers_ValidityLeftAnswer_Text]]
    },
    {
      title: z5Strings.How_Questions_MultipleDevicesQuestion_Text,
      descriptionItems: [[z5Strings.How_Answers_MultipleDevicesAnswer_Text]]
    },
    {
      title: z5Strings.How_Questions_SVODusersQuery_Text,
      descriptionItems: [[z5Strings.How_Answers_SVODusersAnswer_Text]]
    },
    {
      title: z5Strings.How_Questions_AdvancebookingQuestion_Text,
      descriptionItems: [[z5Strings.How_Answers_AdvancebookingAnswer_Text]]
    },
    {
      title: z5Strings.How_Questions_CancellationQuestion_Text,
      descriptionItems: [[z5Strings.How_Answers_CancellationAnswer_Text]]
    }
  ];
};
